//import { Component, OnInit } from '@angular/core';
import { Component, TemplateRef, OnInit } from '@angular/core';
import { UserPage } from '../models/login';
import { ApiService } from '../Services/api-service';
import { UserMasterResponse, User, hoUser, DepotsMst, TerritoryMst, GroupMst, DeptmntMst, DesigMst } from '../models/user';
import { BsModalService, BsModalRef } from 'ngx-bootstrap/modal';
import { PageChangedEvent } from 'ngx-bootstrap/pagination/ngx-bootstrap-pagination';
import { ToastrService } from 'ngx-toastr';
import { NgForm } from '@angular/forms';
import { Organisation, OrganisationResponse } from '../models/organisation';
import { DatePipe } from '@angular/common';
import { ExcelService } from '../excel.service';
@Component({
  selector: 'app-ho-user',
  templateUrl: './ho-user.component.html',
  styleUrls: ['./ho-user.component.css']
})
export class HoUserComponent implements OnInit {
  pagesUser: UserPage = new UserPage();
  users: any[] = [];
  currentPage: any;
  pagesuserorganisation: UserPage = new UserPage();
  modalhead: string = "Add User";
  modalRef: BsModalRef;
  mobileReg: RegExp = /^[6-9]\d{9}$/;
  emailReg: RegExp = /^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/;
  isEdit: boolean = true;
  HOuserReportlistexcel: any[] = []
  reportHoExcel: any[] = []
  totaldata: any;
  isUsrGroupError: boolean = false
  isDepartmentError: boolean = false
  showTerritory: boolean = false;
  isDesignationReportError: boolean = false
  isDesignationError: boolean = false
  isMobileError: boolean = false
  isEmailError: boolean = false
  isJoinDateError: boolean = false
  formval: hoUser = new hoUser();
  ReqDt: hoUser = new hoUser();
  newJoinDate: Date;
  DesigsList: DesigMst[] = [];
  DeptmntsList: DeptmntMst[] = [];
  GroupsList: GroupMst[] = [];
  DepotsList: DepotsMst[] = [];
  isCheckedYes: boolean = false;
  isCheckedNo: boolean = false;
  TerritoryList: TerritoryMst[] = [];
  selectedAll: boolean = false;
  isEditpassword: boolean = false;
  isNoBussinessLine: boolean = false;
  isNoDepot: boolean = false;
  isNoTerritory: boolean = false;
  selectedAllT: boolean = false;
  buttonText: string = "Save";
  submitForm: NgForm;
  dnm: boolean = false;
  bussinessCheck: any;
  show: boolean = false;
  BusinessLine: any = [{ BussinessId: 1, BusinessNm: 'Retail', BusinessCd: 'R', selected: false }, { BussinessId: 2, BusinessNm: 'Industrial', BusinessCd: 'I', selected: false },
  { BussinessId: 3, BusinessNm: 'Projects', BusinessCd: 'P', selected: false }];
  constructor(private excelService: ExcelService, private toastr: ToastrService, private apiService: ApiService, private modalService: BsModalService, private dt: DatePipe) {
    this.pagesUser.Filter = 'FirstName';
  }

  ngOnInit() {
    this.getDepots();
    this.getDepartment(0);
    this.getGroup(0);
    this.getDesig(0);
    this.getUsers(this.pagesUser);
  }

  /////  CR-02 BP-111 (Issue Key) 25-March-2021 Done by Ayush
  DownloadHOUserReport() {
    if (this.users != null) {
      this.apiService.PostApi(this.pagesUser, `HOUser/GetHoUserForExcel`).subscribe((res: any) => {
        this.HOuserReportlistexcel = res.ResponseData
        this.HOuserReportlistexcel.forEach(o => {
          this.reportHoExcel.push(
            {
              FirstName: o.FirstName, LastName: o.LastName, Email: o.Email, Mobile: o.Mobile,
              UserType: o.UserType, FactoryName: o.FactoryName, OrganisationName: o.OrganisationName, Password: o.Password, IsActive: o.IsActive
            }
          )
        });
        this.exportAsXLSX(this.HOuserReportlistexcel)
      })
    }
  }
  exportAsXLSX(HOuserReportlistexcel) {
    this.excelService.exportAsExcelFile(this.HOuserReportlistexcel, 'Ho User Report')
  }

  onSubmit(f: NgForm) {
    debugger
    var dt = f.value;
    if (dt.cpassword != dt.password) {
      this.dnm = true;
      return;
    }
    else {
      this.dnm = false;
    }
    // this.isCheckedYes
    // this.isCheckedNo
    // if(this.isCheckedYes == true && this.isCheckedNo == false){
    //   dt.IsActive = true
    // }else if(this.isCheckedYes == false && this.isCheckedNo == true){
    //   dt.IsActive = false
    // }else{
    //   dt.IsActive = true
    // }
    if (this.formval.IsActive1 || this.formval.IsActive2 || this.formval.IsActive) {
      if (this.formval.IsActive1 == true) {
        dt.IsActive = true;
      }
      else if (this.formval.IsActive2 == true) {
        dt.IsActive = false;
      }
    }
    else {
      dt.IsActive = false;
    }
    // if((dt.firstname == '' || dt.firstname == undefined || dt.firstname == null))

    if (dt.GroupCd == '' || dt.GroupCd == null || dt.GroupCd == undefined) {
      this.isUsrGroupError = true
    }
    if (dt.DeptCd == '' || dt.DeptCd == null || dt.DeptCd == undefined) {
      this.isDepartmentError = true
    } if (dt.GroupCd == '' || dt.GroupCd == null || dt.GroupCd == undefined) {
      this.isUsrGroupError = true
    } if (dt.UsrDesigRpt == '' || dt.UsrDesigRpt == null || dt.UsrDesigRpt == undefined) {
      this.isDesignationReportError = true
    } if (dt.DesigCd == '' || dt.DesigCd == null || dt.DesigCd == undefined) {
      this.isDesignationError = true
    }
    if (dt.fromdate == '' || dt.fromdate == null || dt.fromdate == undefined) {
      this.isJoinDateError = true
    }

    var reqDt = {
      ID: (dt.ID == undefined ? this.formval.ID : dt.ID),
      FirstName: dt.firstname,
      LastName: dt.lastname,
      UsrGroup: dt.GroupCd,
      UsrDeptmnt: dt.DeptCd,
      UsrDesigForRpt: dt.UsrDesigRpt,
      EmpId: dt.employeeID,
      Email: dt.Email,
      Mobile: dt.Mobile,
      Password: (dt.password == undefined ? 'EDIT' : dt.password),
      UsrDesig: dt.DesigCd,
      JoinDt: dt.fromdate,
      IsActive: dt.IsActive,
      CreatedBy: '1',
      BusinessList: this.BusinessLine.filter(x => x.selected === true),
      DepotsList: this.DepotsList.filter(x => x.selected === true),
      TerritoryList: (this.TerritoryList == null ? null : this.TerritoryList.filter(x => x.selected === true)),
    }
    var checkDisabled = false
    if (this.isUsrGroupError == true || this.isDepartmentError == true || this.isDesignationReportError == true || this.isDesignationError == true ||
      this.isJoinDateError == true) {
      checkDisabled = true
    }
    if (reqDt.BusinessList.length < 1) {
      this.isNoBussinessLine = true;
    }
    else {
      this.isNoBussinessLine = false;
    }
    if (reqDt.DepotsList.length < 1) {
      this.isNoDepot = true;
    }
    else {
      this.isNoDepot = false;
    }
    if (reqDt.TerritoryList.length < 1 || checkDisabled == true) {
      this.isNoTerritory = true;
      return
    }
    else {
      this.isNoTerritory = false;
    }
    this.show = true;
    this.apiService.PostApi(reqDt, "HOUser/SaveHOUser").subscribe((response: UserMasterResponse) => {
      if (response.ResponseCode == "200") {
        this.getUsers(this.pagesUser);
        this.resetmodal();
        this.show = false;

        this.toastr.success(response.ResponseMessage, 'Success!', {
          timeOut: 3000
        });
      }
      else {
        this.toastr.warning(response.ResponseMessage, 'Error!', {
          timeOut: 3000,
        });

        this.show = false;
      }
    }, err => {
      this.toastr.warning(err.error.ResponseMessage, 'Error!', {
        timeOut: 3000
      });

      this.show = false;
    });
  }
  radioChange(value) {
    if (value == 'Yes') {
      this.formval.IsActive1 = true;
      this.formval.IsActive2 = false
    }
    else if (value == 'No') {
      this.formval.IsActive2 = true;
      this.formval.IsActive1 = false
    }
  }
  onpagechange() {
    this.pagesUser.page = 1;
    this.getUsers(this.pagesUser);
  }
  getUsers(user: UserPage): any {
    this.show = true;
    this.pagesUser.UserType = 10;
    this.pagesUser.IsActive = '%';
    this.pagesUser.FilterBY = '';
    this.apiService.PostApi(this.pagesUser, "HOUser/GetAllUser").subscribe((response: any) => {
      if (response.ResponseCode == "200") {
        this.users = response.ResponseData;
        this.totaldata = response.ResponseData[0].TotalCount;
        if (this.totaldata < parseInt(this.pagesUser.pageSize)) {
          this.currentPage = 1;
        }
      }
      else {
        this.users = null;
        this.show = false;
      }
    }, err => {
      //this.users = null;
      this.show = false;
    });
    this.show = false;
  }
  pageChanged(event: PageChangedEvent): void {
    //  alert(event.page)
    const startItem = (event.page - 1) * event.itemsPerPage;
    const endItem = event.page * event.itemsPerPage;
    this.pagesUser.page = event.page;
    this.getUsers(this.pagesUser);
    this.currentPage = event.page + 1;
  }
  getDepots(): any {

    this.show = true;

    this.pagesUser.UserType = 1;
    if (this.DepotsList != null) {

      this.DepotsList = this.DepotsList.slice(0, 0);
    }

    this.apiService.GetApi(this.pagesUser, "HOUser/GetAllDepot").subscribe((response: any) => {
      if (response.ResponseCode == "200") {
        this.DepotsList = response.ResponseData;
      }
      else {
        this.DepotsList = null;

        this.show = false;
      }
    }, err => {
      this.DepotsList = null;

      this.show = false;
    });

    this.show = false;
  }
  //  fixUTCDate(date): any {
  //   if (date) {
  //     date.setTime(new Date(new Date(date.getTime() - date.getTimezoneOffset() * 60 * 1000).toUTCString()));
  //     return date;
  //   }
  //   return null;
  // }
  getTerritory(): any {
    this.show = true;
    if (this.DepotsList == null)
      return;
    this.apiService.PostApi(this.DepotsList.filter(x => x.selected === true), "HOUser/GetAllTerritory").subscribe((response: any) => {
      if (response.ResponseCode == "200") {
        this.TerritoryList = response.ResponseData;
        this.showTerritory = true
      }
      else {
        this.TerritoryList = null;
        this.show = false;
        this.showTerritory = false
      }
    }, err => {
      this.TerritoryList = null;
      this.showTerritory = false
      this.show = false;
    });

    this.show = false;
  }
  getGroup(GroupId: number): any {
    this.show = true;

    this.apiService.GetApi(GroupId, "Other/GetAllGroup?GroupId=" + GroupId).subscribe((response: any) => {
      if (response.ResponseCode == "200") {
        this.GroupsList = response.ResponseData;
      }
      else {
        this.GroupsList = null;

        this.show = false;
      }
    }, err => {
      this.GroupsList = null;

      this.show = false;
    });

    this.show = false;
  }
  getDepartment(DeptId: number): any {
    this.apiService.GetApi(DeptId, "Other/GetAllDepart?DeptId=" + DeptId).subscribe((response: any) => {
      if (response.ResponseCode == "200") {
        this.DeptmntsList = response.ResponseData;
      }
      else {
        this.DeptmntsList = null;
      }
    }, err => {
      this.DeptmntsList = null;
    });
  }
  getDesig(DesigId: number): any {
    this.apiService.GetApi(DesigId, "Other/GetAllDesig?DesigId=" + DesigId).subscribe((response: any) => {
      if (response.ResponseCode == "200") {
        this.DesigsList = response.ResponseData;
      }
      else {
        this.DesigsList = null;
      }
    }, err => {
      this.DesigsList = null;
    });
  }
  resetmodal() {
    this.modalhead = "Add User";
    this.dnm = false;
    this.isNoBussinessLine = false;
    this.isNoDepot = false;
    this.isNoTerritory = false;
    this.isEdit = true;
    //this.numberedit = "";
    //this.isDisabled = "false";
    this.formval.EmpId = '';
    this.formval.UsrGroup = '';
    this.formval.UsrDeptmnt = '';
    this.formval.UsrDesigForRpt = '';
    this.formval.UsrDesig = '';
    this.formval.FirstName = '';
    this.formval.LastName = '';
    this.formval.Email = '';
    this.formval.Mobile = '';
    this.formval.fromdate = null;
    //this.formval.Organisation = "0";
    this.formval.Password = '';
    this.formval.cpassword = '';
    //this.formval.ShopName = '';
    //this.formval.FactoryName = '';
    //this.formval.HQName = '';
    this.selectedAll = false;
    this.selectedAllT = false;
    this.isUsrGroupError = false
    this.isDepartmentError = false
    this.isDesignationReportError = false
    this.isDesignationError = false
    this.isJoinDateError = false
    this.getDepots();
    this.getTerritory();

    this.buttonText = "Save";
    //let arr = Array(3).fill({}) // [{}, {}, {}]
    //arr[0].hi = "hi"
    //this.DepotsList.fill().selected = false;
    this.modalRef.hide();
  }

  selectAll() {
    for (var i = 0; i < this.DepotsList.length; i++) {
      this.DepotsList[i].selected = this.selectedAll;
    }
  }
  checkIfAllSelected() {
    this.selectedAll = this.DepotsList.every(function (item: any) {
      return item.selected == true;
    })
  }

  selectAllT() {
    for (var i = 0; i < this.TerritoryList.length; i++) {
      this.TerritoryList[i].selected = this.selectedAllT;
    }
  }
  checkIfAllSelectedT() {
    this.selectedAllT = this.TerritoryList.every(function (item: any) {
      return item.selected == true;
    })
  }
  numberOnly(event): boolean {
    const charCode = (event.which) ? event.which : event.keyCode;
    if (charCode > 31 && (charCode < 48 || charCode > 57)) {
      return false;
    }
    return true;
  }
  alphaOnly(event): boolean {
    const charCode = (event.which) ? event.which : event.keyCode;

    if (charCode > 31 && (charCode < 48 || charCode > 57)) {
      return true;
    }
    return false;
  }
  spaceNotAllowed(event): boolean {
    const charCode = (event.which) ? event.which : event.keyCode;

    if (charCode == 32) {
      return false;
    }
    return true;
  }
  getTerritoryBuissnessData(userId) {
    this.apiService.GetApi(userId, 'HOUser/GetDtlsHoUsr?UsrId=' + userId).subscribe((resp: any) => {
      if (resp.BussinessList.length > 0) {
        for (var i = 0; i < resp.BussinessList.length; i++) {
          if (resp.BussinessList[i].BussinessId == 1 || resp.BussinessList[i].BussinessId == 2 || resp.BussinessList[i].BussinessId == 3) {
            this.BusinessLine[resp.BussinessList[i].BussinessId - 1].selected = true;
          }
        }
      }
      if (resp.DepotList.length > 0) {
        for (var i = 0; i < this.DepotsList.length; i++) {
          for (var j = 0; j < resp.DepotList.length; j++) {
            if (this.DepotsList[i].DepotId == resp.DepotList[j].DepotId) {
              this.DepotsList[i].selected = true;
            }
          }
        }
      }
      if (resp.TrtryList.length > 0) {
        this.TerritoryList = JSON.parse(JSON.stringify(resp.TerritoryMst));
        var checkMatch = 0;
        for (var i = 0; i < this.TerritoryList.length; i++) {
          checkMatch = 0;
          for (var j = 0; j < resp.TrtryList.length; j++) {
            if (this.TerritoryList[i].TrtryId == resp.TrtryList[j].TrtryId) {
              checkMatch = 1;
              this.TerritoryList[i].selected = true;
              break;
            }
          }
          if (checkMatch == 0) {
            this.TerritoryList[i].selected = false;
          }
        }
      }

    })
  }
  edituser(template, user) {
    debugger
    this.showTerritory = true
    for (var i = 0; i < this.DepotsList.length; i++) {
      this.DepotsList[i].selected = false;
    }
    for (var i = 0; i < this.BusinessLine.length; i++) {
      this.BusinessLine[i].selected = false;
    }
    this.modalhead = "Edit User"
    this.isEditpassword = true;
    if (user.IsActive == true) {
      this.isCheckedYes = true;
      this.isCheckedNo = false;
      this.formval.IsActive1 = true;
      this.formval.IsActive2 = false
    }
    else if (user.IsActive == false) {
      this.isCheckedNo = true;
      this.isCheckedYes = false;
      this.formval.IsActive1 = false
      this.formval.IsActive2 = true
    }
    // user.JoinDt=this.dt.transform(user.JoinDt, 'MM/dd/yyyy');
    var dateFrom = this.dt.transform(user.JoinDt, 'E LLL dd y 00:00:00 zzzz');
    var dateFromSplitted = dateFrom.split('+');
    var dateConcat = dateFromSplitted[0] + '+0530 (India Standard Time)';
    var dateTransform = new Date(this.dt.transform(user.JoinDt, 'MM/dd/yyyy'));
    this.formval.ID = user.ID;
    this.formval.FirstName = user.FirstName;
    this.formval.EmpId = user.EmpId
    this.formval.LastName = user.LastName;
    this.formval.UsrGroup = user.UsrGroup;
    this.formval.UsrDeptmnt = user.UsrDeptmnt;
    this.formval.UsrDesigForRpt = user.UsrDesigForRpt;
    this.formval.Email = user.Email;
    this.formval.Mobile = user.Mobile;
    this.formval.UsrDesig = user.UsrDesig;
    this.formval.fromdate = new Date(dateConcat);
    this.formval.IsActive = user.IsActive;
    this.formval.cpassword = user.Password;
    this.formval.Password = user.Password;
    let config = { backdrop: true, ignoreBackdropClick: true, class: 'modal-lg' };
    this.modalRef = this.modalService.show(template, config);
    this.getTerritoryBuissnessData(user.ID)
  }

  openModal(template: TemplateRef<any>) {
    let config = { backdrop: true, ignoreBackdropClick: true, class: 'modal-lg' };
    this.formval.IsActive = true;
    this.formval.ID = null;
    this.isCheckedYes = true;
    this.formval.IsActive1 = true;
    for (var i = 0; i < this.BusinessLine.length; i++) {
      this.BusinessLine[i].selected = false;
    }
    this.isEditpassword = false;
    this.modalRef = this.modalService.show(template, config);
  }
}
